module.exports = __webpack_public_path__ + "img/nodata_yellow.dea482a0.png";